// extracted by mini-css-extract-plugin
module.exports = {"text":"_2PYXA0","action":"o-1S24","shine-lines":"CA07uB"};